import { render, staticRenderFns } from "./MensalidadeAluno.vue?vue&type=template&id=676f2daf"
import script from "./MensalidadeAluno.vue?vue&type=script&lang=js"
export * from "./MensalidadeAluno.vue?vue&type=script&lang=js"
import style0 from "./MensalidadeAluno.vue?vue&type=style&index=0&id=676f2daf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports